module.exports = __webpack_public_path__ + "static/media/icon_69.f0c564c8.svg";